import { css } from '@emotion/css';

export const PlayIconStyles = css`
  top: calc(50% - 2rem);
  left: calc(50% - 2rem);
`;
